var loadMessgeListInterval;

import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import { createConsumer } from '@rails/actioncable';

// import MessageGroupsUsersBox from "./message_groups_users_box";
import MessageBoxList from './message_box_list';
import Loader from '../loader';
// import SideGroupArea from "./side_group_area";
import MessageSendForm from './message_send_form';
import ModalConfirm from '../modal/modal_confirm';
import ModalAlert from '../modal/modal_alert';

export default createReactClass({
  displayName: 'Root',
  propTypes: {
    messageGroupId: PropTypes.number.isRequired,
    isBalloonDisp: PropTypes.bool,
    isCompany: PropTypes.bool,
  },
  getInitialState() {
    return {
      loading: true,
      messages: [],
      messageGroupsUsers: [],
      updatedMessages: [],
      maxMessageId: 0,
      calledAt: '',
      MessageCount: 0,
      unreadMessageCount: 0,
      isFirstLoad: true,
      file: {},
      isSubmit: false,
      isBalloonDisp: PropTypes.bool,
      isCompany: this.props.isCompany ? this.props.isCompany : false,
      messageListPadding: 0,
      isWsConnected: true,
      wsClientIds: {},
    };
  },
  loadRoomInfoFromServer() {
    $.ajax({
      url: '/api/message/room_info',
      dataType: 'json',
      cache: false,
      data: {
        message_group_id: this.props.messageGroupId,
      },
    })
      .done(
        function (data) {
          // success
          this.setState({
            loading: false,
            messageGroup: data.messageGroup,
            messageGroupsUsers: data.messageGroupsUsers,
          });
        }.bind(this),
      )
      .fail(
        function () {
          // error
        }.bind(this),
      );
  },
  loadMessageListFromServer() {
    $.ajax({
      url: '/api/message/room',
      dataType: 'json',
      cache: false,
      data: {
        message_group_id: this.props.messageGroupId,
        max_message_id: this.state.maxMessageId,
        prev_called_at: this.state.calledAt,
      },
    })
      .done(
        function (data) {
          // success
          var updatedMessages = {};
          data.updatedMessages.forEach(function (message) {
            updatedMessages[message.id] = message;
          });
          let prevMessageId = 0;
          var messages = this.state.messages
            .concat(data.messages)
            .map(function (message) {
              if (prevMessageId !== message.id) {
                if (!updatedMessages[message.id]) return message;
                message = updatedMessages[message.id];
                prevMessageId = message.id;
                return message;
              }
            });
          var maxMessageId = data.maxMessageId
            ? data.maxMessageId
            : this.state.maxMessageId;
          this.setState(
            {
              loading: false,
              messages: messages,
              maxMessageId: maxMessageId,
              calledAt: data.calledAt,
              // messageCount: data.messageCount,
              unreadMessageCount: data.unreadMessageCount,
            },
            function () {
              if (this.state.isFirstLoad) {
                $('.flexContainer').innerHeight(window.innerHeight);
                this.scrollToBottom();
                this.setState({
                  isFirstLoad: false,
                });
              }

              if (this.state.isSubmit) {
                $('.containerMessage').height('');
                this.setState({
                  isSubmit: false,
                });
                this.scrollToBottom();
              }
            },
          );
        }.bind(this),
      )
      .fail(
        function () {
          // error
        }.bind(this),
      );
  },
  pauseLoading() {
    clearInterval(loadMessgeListInterval);
  },
  startLoading() {
    // ポーリング撤廃済み: ActionCable でリアルタイム更新するため何もしない
  },
  componentDidMount() {
    this.loadRoomInfoFromServer();
    this.loadMessageListFromServer();
    $(window).on(
      'focus',
      function () {
        // this.loadMessageListFromServer();
      }.bind(this),
    );
    if (window.innerWidth <= 767) {
      $(window).on('resize', function () {
        $('.flexContainer').innerHeight(window.innerHeight);
      });
    }

    this.consumer = createConsumer();
    this.subscription = this.consumer.subscriptions.create(
      {
        channel: 'MessageRoomChannel',
        message_group_id: this.props.messageGroupId,
      },
      {
        connected: () => {
          this.setState({ isWsConnected: true });
          if (this.wasDisconnected) {
            this.loadMessageListFromServer();
            this.wasDisconnected = false;
          }
        },
        disconnected: () => {
          this.setState({ isWsConnected: false });
          this.wasDisconnected = true;
        },
        received: (data) => {
          this.handleWsReceived(data);
        },
      },
    );
  },
  componentWillUnmount() {
    clearInterval(loadMessgeListInterval);
    if (this.subscription) this.subscription.unsubscribe();
    if (this.consumer) this.consumer.disconnect();
  },
  handleWsReceived(data) {
    if (data.type === 'message_created') {
      const incoming = data.message;
      const clientId = data.client_id;
      let nextMessages = [...this.state.messages];

      if (clientId) {
        // 自分の送信 → 楽観メッセージを置換
        const idx = nextMessages.findIndex((m) => m.client_id === clientId);
        if (idx >= 0) {
          nextMessages[idx] = { ...incoming, status: 'sent' };
        } else if (!nextMessages.find((m) => m.id === incoming.id)) {
          nextMessages.push({ ...incoming, status: 'sent' });
        }
      } else {
        // 他人の送信
        if (!nextMessages.find((m) => m.id === incoming.id)) {
          nextMessages.push({ ...incoming, status: 'sent' });
        }
      }

      this.setState({
        messages: nextMessages,
        maxMessageId: Math.max(this.state.maxMessageId, incoming.id || 0),
      });
    } else if (data.type === 'read_status_changed') {
      const updated = this.state.messages.map((m) =>
        m.id === data.message_id
          ? { ...m, already_readers_count: data.already_readers_count }
          : m,
      );
      this.setState({ messages: updated });
    }
  },
  handleRetryMessage(clientId) {
    const failed = this.state.messages.find(
      (m) => m.client_id === clientId && m.status === 'failed',
    );
    if (!failed) return;

    const updated = this.state.messages.map((m) =>
      m.client_id === clientId ? { ...m, status: 'sending' } : m,
    );
    this.setState({ messages: updated });

    this.handleMessageSubmit({ body: failed.body });
  },
  componentDidUpdate(prevProps, prevState) {
    var ancLatestMessage = this.ancLatestMessage;
    if (
      this.state.loading ||
      prevState.messages[prevState.messages.length - 1] === undefined ||
      this.state.messages[prevState.messages.length - 1] === undefined ||
      prevState.messages[prevState.messages.length - 1].body !==
        this.state.messages[this.state.messages.length - 1].body
    ) {
      if (window.innerWidth > 767) {
        // PC
        $('.block-messageList').scrollTop(ancLatestMessage.offsetTop);
      } else {
        // スマホ
        $('html, body').scrollTop(ancLatestMessage.offsetTop);
      }
    }
  },
  handleMessageSubmit: function (message) {
    var clientId =
      typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : 'cid_' + Date.now() + '_' + Math.random().toString(36).slice(2);

    var optimisticMsg = {
      client_id: clientId,
      id: null,
      body: message['body'],
      sender_id: this.props.currentUser ? this.props.currentUser.id : null,
      status: 'sending',
      created_at: new Date().toISOString(),
      user: this.props.currentUser || {},
      messages_like_users: [],
      already_readers_count: 0,
    };

    this.setState({
      messages: [...this.state.messages, optimisticMsg],
      isSubmit: true,
    });

    var self = this;
    var timeoutId = setTimeout(function () {
      var updated = self.state.messages.map(function (m) {
        return m.client_id === clientId ? { ...m, status: 'failed' } : m;
      });
      self.setState({ messages: updated });
    }, 10000);

    $.ajax({
      url: '/api/message/room_reply',
      type: 'POST',
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
      data: {
        body: message['body'],
        message_group_id: this.props.messageGroupId,
        parent_message_id: message['parent_message_id'],
        client_id: clientId,
      },
      cache: false,
    })
      .done(
        function () {
          // POST成功後も timeoutId はクリアしない。
          // WebSocket message_created を受信した時点で handleWsReceived がクリアする。
          // 10秒以内にWSが来なければタイムアウトで failed 化する（Redis障害等のフォールバック）。
        }.bind(this),
      )
      .fail(
        function () {
          clearTimeout(timeoutId);
          var updated = this.state.messages.map(function (m) {
            return m.client_id === clientId ? { ...m, status: 'failed' } : m;
          });
          this.setState({ messages: updated, isSubmit: false });
        }.bind(this),
      );
  },
  setFile: function (file) {
    this.setState({
      file: file,
    });
  },
  openModal: function () {
    this.modalConfirm.openModal();
  },
  handlePhotoSubmit() {
    var clientId =
      typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : 'cid_' + Date.now() + '_' + Math.random().toString(36).slice(2);

    var optimisticMsg = {
      client_id: clientId,
      id: null,
      body: '',
      sender_id: this.props.currentUser ? this.props.currentUser.id : null,
      status: 'sending',
      created_at: new Date().toISOString(),
      user: this.props.currentUser || {},
      messages_like_users: [],
      already_readers_count: 0,
      picture_medium: null,
    };

    this.setState({
      messages: [...this.state.messages, optimisticMsg],
      isSubmit: true,
    });

    var self = this;
    var timeoutId = setTimeout(function () {
      var updated = self.state.messages.map(function (m) {
        return m.client_id === clientId ? { ...m, status: 'failed' } : m;
      });
      self.setState({ messages: updated });
    }, 10000);

    var formData = new FormData();
    formData.append('file', this.state.file);
    formData.append('message_group_id', this.props.messageGroupId);
    formData.append('client_id', clientId);
    $.ajax({
      type: 'POST',
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
      url: '/api/message/send_photo',
      cache: false,
      data: formData,
      processData: false,
      contentType: false,
    })
      .done(
        function () {
          // POST成功後も timeoutId はクリアしない。
          // WebSocket message_created を受信した時点で handleWsReceived がクリアする。
          // 10秒以内にWSが来なければタイムアウトで failed 化する（Redis障害等のフォールバック）。
        }.bind(this),
      )
      .fail(
        function () {
          clearTimeout(timeoutId);
          this.modalAlert.openModal();
          var updated = this.state.messages.map(function (m) {
            return m.client_id === clientId ? { ...m, status: 'failed' } : m;
          });
          this.setState({ messages: updated, isSubmit: false });
        }.bind(this),
      );
  },
  scrollToBottom() {
    var target = $('.block-messageList');
    if (window.innerWidth > 767) {
      $('html, body').scrollTop(target.height());
    } else {
      $('.containerMessage').scrollTop(target.height());
    }
  },
  setMessageListPadding(messageListPadding) {
    this.setState(
      {
        messageListPadding,
      },
      () => {
        this.scrollToBottom();
      },
    );
  },
  render() {
    var currentUserId = this.props.currentUser.id;
    // var numOfMembers = this.state.messageGroupsUsers.length;
    // var numOfMembersDisp = "";
    // if (numOfMembers >= 3) {
    //   numOfMembersDisp = "  (" + numOfMembers + ")";
    // }
    // var user_count = this.state.messageGroupsUsers.length;
    // var i = 0;
    // var messageGroupsUsers = this.state.messageGroupsUsers.map(function(
    //   group_user
    // ) {
    //   i++;
    //   var noUser = "";
    //   if (numOfMembers < 2) {
    //     noUser = "ユーザーが退出しました";
    //   }
    //   return (
    //     <span key={group_user.id}>
    //       <MessageGroupsUsersBox
    //         messageGroupsUser={group_user}
    //         currentUserId={currentUserId}
    //         key={group_user.id}
    //       />
    //       {i < user_count && currentUserId != group_user.user_id ? "、" : ""}
    //       {noUser}
    //     </span>
    //   );
    // });
    // var unreadBadge = "";
    // if (this.state.unreadMessageCount > 0) {
    //   unreadBadge = (
    //     <span className="badge g-color-white g-bg-red g-rounded-50x">
    //       {this.state.unreadMessageCount}
    //     </span>
    //   );
    // }

    // var messageGroupsUsersList = (
    //   <div className="flexHeader">
    //     <div className="block-header-message fixed hidden-xs">
    //       <div
    //         className="title-message-member-group block-header-message-wrap2"
    //         style={{ fontWeight: "bold" }}
    //       >
    //         {/* <a className="ttl-message-group1" href="" data-toggle="modal" data-target="#messageUsersSetting"> */}
    //         <div className="one-line-ellipsis">{messageGroupsUsers}</div>
    //         <div className="num-of-members">
    //           
    //           {numOfMembersDisp}
    //           {/* <span className="icon-caret2"><i className="fas fa-angle-down" aria-hidden="true"></i></span> */}
    //         </div>
    //         {/* </a> */}
    //       </div>
    //     </div>

    //     <div
    //       id="sp-member-header"
    //       className="block-header-message is-type-sp visible-xs-block"
    //     >
    //       <div className="block-header-message-wrap1">
    //         {!this.props.isWebViewTabApp && (
    //           <a className="btn-back-member" href="/message">
    //             <span>
    //               <i className="fas fa-chevron-left" aria-hidden="true" />
    //               {unreadBadge}
    //             </span>
    //           </a>
    //         )}
    //       </div>
    //       <div className="title-message-member-group block-header-message-wrap2">
    //         <a
    //           className="ttl-message-group1"
    //           href=""
    //           data-toggle="modal"
    //           data-target="#messageUsersSetting"
    //         >
    //           <div className="one-line-ellipsis">{messageGroupsUsers}</div>{" "}
    //           <div className="num-of-members">
    //             {numOfMembersDisp}
    //             <span className="icon-caret is-type-ttl">
    //               <i className="fas fa-angle-down" aria-hidden="true" />
    //             </span>
    //           </div>
    //         </a>
    //       </div>
    //     </div>
    //   </div>
    // );
    var havePictureLength = this.state.messages.filter(
      (v) => v.picture_medium !== null,
    ).length;
    var num = 0;

    const isBalloonDisp = this.props.isBalloonDisp;
    let isFirstLoad = this.state.isFirstLoad;
    var onRetry = this.handleRetryMessage;
    var messageBoxList = this.state.messages.map(function (message) {
      if (message.picture_medium !== null) num++;
      return (
        <MessageBoxList
          message={message}
          currentUserId={currentUserId}
          isLastPictureMessage={
            message.picture_medium !== null && havePictureLength === num
          }
          key={message.id || message.client_id}
          isBalloonDisp={isBalloonDisp}
          isFirstLoad={isFirstLoad}
          onRetry={onRetry}
        />
      );
    });
    // var messageListAll = '';
    // if (window.innerWidth > 767) {  // PC
    //   messageListAll = <div>
    //     {messageGroupsUsersList}
    //     <div id="block-message-container" className="containerMessage">
    //       <div className="block-message">
    //         <SideGroupArea currentUser={this.props.currentUser} messageGroupId={this.props.messageGroupId} circleId={this.props.circleId} eventId={this.props.eventId} isCompany={this.state.isCompany} />

    //         <div className="block-messageList" ref="blockMessageList">
    //           <div className="block-messageListInner" ref="blockMessageListInner">
    //             {messageBoxList}
    //             <Loader isActive={this.state.loading} />
    //             <div id="ancLatestMessage" ref="ancLatestMessage"></div>
    //           </div>
    //           <MessageSendForm
    //             onMessageSubmit={this.handleMessageSubmit}
    //             setFile = {this.setFile}
    //             openModal = {this.openModal}
    //             messageGroupId={this.props.messageGroupId}
    //             isBalloonDisp={this.props.isBalloonDisp}
    //           />
    //         </div>
    //       </div>
    //     </div>
    //   </div>;
    // } else {  // スマホ
    //   messageListAll = <div id="block-message-container" className="containerMessage flexMessage">
    //     <div className="block-messageList" ref="blockMessageList">
    //       {messageBoxList}
    //     </div>

    //     <Loader isActive={this.state.loading} />
    //     <div id="ancLatestMessage" ref="ancLatestMessage"></div>
    //   </div>;
    // }

    var messageListAll = (
      <div
        className={`${
          window.innerWidth > 767 ? 'bg-gray h-main100vh' : ''
        } pb-5`}
        style={{ paddingBottom: this.state.messageListPadding }}
      >
        {!this.state.isWsConnected && (
          <div
            className="ws-disconnected-banner alert alert-warning"
            style={{ padding: '8px', textAlign: 'center', margin: 0 }}
          >
            接続が切れています。再接続中...
          </div>
        )}
        <div className="block-messageList container col-md-8 col-lg-6">
          <ul className="list-unstyled mb-2 pt-3">{messageBoxList}</ul>
          <Loader isActive={this.state.loading} />
          <div
            id="ancLatestMessage"
            ref={(c) => {
              this.ancLatestMessage = c;
            }}
          />
        </div>
      </div>
    );

    var reactRoot = '';

    if (window.innerWidth > 767) {
      // PC
      reactRoot = (
        <div className="react-root">
          <div>
            {messageListAll}
            <MessageSendForm
              onMessageSubmit={this.handleMessageSubmit}
              loadMessageListFromServer={this.loadMessageListFromServer}
              pauseLoading={this.pauseLoading}
              startLoading={this.startLoading}
              setFile={this.setFile}
              setMessageListPadding={this.setMessageListPadding}
              openModal={this.openModal}
              messageGroupId={this.props.messageGroupId}
              isBalloonDisp={this.props.isBalloonDisp}
            />
            <ModalConfirm
              ref={(c) => {
                this.modalConfirm = c;
              }}
              title="画像の送信"
              content="よろしいですか？"
              approveFunc={this.handlePhotoSubmit}
            />
            <ModalAlert
              ref={(c) => {
                this.modalAlert = c;
              }}
              title="画像の送信"
              content="画像の送信に失敗しました。"
            />
          </div>
        </div>
      );
    } else {
      // スマホ
      reactRoot = (
        <div className="reactRoot">
          <div className="bg-gray h-main100vh">
            {messageListAll}
            <MessageSendForm
              onMessageSubmit={this.handleMessageSubmit}
              loadMessageListFromServer={this.loadMessageListFromServer}
              pauseLoading={this.pauseLoading}
              startLoading={this.startLoading}
              setFile={this.setFile}
              setMessageListPadding={this.setMessageListPadding}
              openModal={this.openModal}
              messageGroupId={this.props.messageGroupId}
              isBalloonDisp={this.props.isBalloonDisp}
            />
            <ModalConfirm
              ref={(c) => {
                this.modalConfirm = c;
              }}
              title="画像の送信"
              content="よろしいですか？"
              approveFunc={this.handlePhotoSubmit}
            />
            <ModalAlert
              ref={(c) => {
                this.modalAlert = c;
              }}
              title="画像の送信"
              content="画像の送信に失敗しました。"
            />
          </div>
        </div>
      );
    }

    return reactRoot;
  },
});

// var prevTargetScrollHeight;
